export enum OneNoteUserEventsKeys {
  TranscriptionSessionId = "TranscriptionSessionId",
  EventCategory = "EventCategory",
  EventType = "EventType",
  EventDirection = "EventDirection",
  OneNotePageIndex = "OneNotePageIndex",
  OneNotePageId = "OneNotePageId",
  OneNoteSectionId = "OneNoteSectionId",
  OneNoteNotebookId = "OneNoteNotebookId",
  TranscriptionState = "TranscriptionState",
  EventInfo = "EventInfo"
};